<template>
  <div class="tournament-content-tab tab-numeration" v-bind:class="{'tournament-content-active-tab':activeTab == 11}">

    <modal name="category-section-form-modal" classes="v--modal adm-modal" :adaptive=true :minHeight=300 height="auto" :minWidth=320 width="92%" :maxWidth=560
           :scrollable=true>
      <form-category-section :formAddCategory="formCategoryData"></form-category-section>
    </modal>


    <modal name="section-form-modal" classes="v--modal adm-modal" :adaptive=true :minHeight=300 height="auto" :minWidth=320 width="92%" :maxWidth=640
           :scrollable=true>
      <form-section :formAddCategory="formSectionData"></form-section>
    </modal>

    <!-- Шапка -->
    <section class="adm-panel adm-head num-head">
      <h3 class="adm-title">Нумерація поєдинків</h3>
      <div class="num-head-stats">
        <span class="adm-chip"><tkd-icon name="section"/> Відділень: {{ orderedSections.length }}</span>
        <span class="adm-chip" :class="availableWithSportsmans > 0 ? 'warn' : 'ok'">
          Без відділення: {{ availableProtocols.length }}<template v-if="availableWithSportsmans > 0"> (з учасниками: {{ availableWithSportsmans }})</template>
        </span>
        <span class="adm-chip num-saving" v-if="isBusy" role="status"><tkd-icon name="loader"/> Збереження…</span>
      </div>
      <button type="button" @click="addNewSection" class="adm-btn adm-btn-primary">
        <span aria-hidden="true"><tkd-icon name="plus"/></span> Нове відділення
      </button>
    </section>

    <div class="num-workspace category-days categories-container">
      <!-- Ліворуч: нерозподілені категорії -->
      <aside class="adm-panel num-picker">
        <tournament-category-list
          :categories="availableProtocols"
          title="Нерозподілені"
          list-id="category_list_numeration"
          item-class="numeration-category-item"
          :selected-id="selectedCategoryId"
          :highlight-selected="false"
          :picked-ids="selectedCategoryIds"
          :draggable-items="true"
          wrapper-columns="minmax(0, 1fr)"
          list-columns="minmax(0, 1fr)"
          :show-select-all="true"
          :all-selected="allCategoriesSelected"
          @toggle-all="toggleAllCategoriesSelection"
          @item-click="toggleCategoryFromClick"
          @item-dragstart="onCategoryDragStart"
          @item-dragend="onCategoryDragEnd"
          @filtered-change="syncVisibleCategories">
          <template #item-overlay="{ item }">
            <input type="checkbox"
                   class="category-selection-checkbox category-selection-checkbox-floating"
                   :checked="isCategorySelected(item.id)"
                   :aria-label="'Вибрати ' + (item.fullname || item.name)"
                   @click.stop
                   @change="toggleCategorySelection(item.id, $event.target.checked)">
          </template>
        </tournament-category-list>
        <p class="num-picker-empty" v-if="!availableProtocols.length"><tkd-icon name="check-circle"/> Усі категорії розподілено по відділеннях</p>
      </aside>

      <!-- Праворуч: відділення -->
      <div class="num-sections sections-block">
        <div class="num-selection-bar" v-if="selectedCategoryIds.length" role="status">
          <span>Вибрано <b>{{ selectedCategoryIds.length }}</b> — перетягніть у відділення або натисніть «Додати сюди»</span>
          <button type="button" class="adm-btn adm-btn-sm adm-btn-ghost" @click="clearCategorySelection()"><tkd-icon name="close"/> Скасувати вибір</button>
        </div>

        <div class="adm-empty" v-if="!orderedSections.length">
          <div class="adm-empty-icon" aria-hidden="true"><tkd-icon name="section"/></div>
          <p>Ще немає відділень</p>
          <span class="num-hint">Створіть відділення (наприклад, «Татамі 1»), потім перетягніть у нього категорії.</span>
          <button type="button" class="adm-btn adm-btn-primary" @click="addNewSection"><span aria-hidden="true"><tkd-icon name="plus"/></span> Створити відділення</button>
        </div>

        <div class="sections-lanes" ref="sectionsLanes">
          <div class="section-lane"
               v-for="section in orderedSections"
               :key="'isection_'+section.id"
               :data-section-id="section.id"
               :class="{'is-drop-target': draggingCategoryIds.length, 'is-drag-over': dragOverSectionId === section.id}"
               @dragover="onLaneDragOver(section, $event)"
               @dragleave="onLaneDragLeave(section, $event)"
               @drop="onLaneDrop(section, $event)">
            <div class="section-lane-card">
              <div class="section-card">
                <span class="section-drag-handle" title="Перетягніть, щоб змінити порядок відділень" aria-label="Змінити порядок">⠿</span>
                <span class="start-number" title="Номер першого поєдинку">№ {{section.start_number !== '' && section.start_number !== null && section.start_number !== undefined ? section.start_number : '—'}}</span>
                <span class="section-name">{{section.name}}</span>
                <button type="button" class="adm-icon-btn section-edit" @click.stop="updateSection(section)" title="Редагувати відділення" aria-label="Редагувати відділення"><tkd-icon name="edit"/></button>
              </div>

              <div class="section-stats">
                <span class="adm-chip"><tkd-icon name="section"/> {{ getVisibleCategoriesForSection(section.id).length }} кат.</span>
                <span class="adm-chip"><tkd-icon name="team"/> {{ section.count_sportsmans || 0 }}</span>
                <span class="adm-chip"><tkd-icon name="kyorugi"/> {{ getSectionFightCount(section.id) }} пое.</span>
                <span class="adm-chip" v-if="section.max_category" title="Максимальна категорія">макс. {{ section.max_category }}</span>
              </div>

              <div class="section-actions">
                <button type="button" class="adm-btn adm-btn-sm adm-btn-primary"
                        v-if="selectedCategoryIds.length"
                        :disabled="isAssigning"
                        @click.stop="assignSelectedCategoriesToSection(section)">
                  <tkd-icon name="arrow-down"/> Додати сюди ({{ selectedCategoryIds.length }})
                </button>
                <button type="button" class="adm-btn adm-btn-sm" @click.stop="numerateSection(section)"
                        :disabled="!getVisibleCategoriesForSection(section.id).length"
                        title="Пронумерувати поєдинки цього відділення"><tkd-icon name="numbering"/> Пронумерувати</button>
                <a class="adm-btn adm-btn-sm" target="_blank" rel="noopener"
                   :href="'https://app.taekwondo.com.ua/tournament-result/print-section-pdf?id='+section.id+'&tid='+tournamentOne.data.item.id"
                   title="Завантажити PDF відділення"><tkd-icon name="file"/> PDF</a>
              </div>

              <div class="section-categories-list" :data-section-id="section.id">
                <div :data-category-id="item.id"
                     class="category-item sortable-category-drag-item section-category-item numeration-category-item"
                     :class="getNumerationCategoryClass(item)"
                     v-for="item in getVisibleCategoriesForSection(section.id)"
                     :key="section.id +'_dd1_'+item.id"
                     title="Перетягніть, щоб змінити порядок або перенести в інше відділення">
                  <div class="category-item-inner">
                    <div class="category-item-side">
                      <span class="category-count-sportsmans">{{ getCategoryCount(item) }}</span>
                    </div>
                    <div class="category-item-main">
                      <span class="category-item-name">{{ item.fullname }}<span class="adm-chip danger" v-if="!item.fullname">не вказано</span></span>
                      <span class="numeration-dop-info">
                        <span v-if="item.type == 1" class="adm-chip">керугі</span>
                        <span v-if="item.type == 2" class="adm-chip">пумсе</span>
                        <span v-if="item.show_type == 1" class="adm-chip">сітка</span>
                        <span v-if="item.show_type == 2" class="adm-chip">список</span>
                        <span v-if="item.type == 2 && (item.poomsae_type == 1 || item.poomsae_type == 2)" class="adm-chip">
                          {{ item.poomsae_type == 1 ? 'традиційне' : 'вільне' }}
                        </span>
                      </span>
                    </div>
                    <div class="category-item-tools">
                      <button type="button" class="adm-icon-btn sm"
                              title="Перенести в інше відділення"
                              aria-label="Перенести в інше відділення"
                              @mousedown.stop
                              @click.stop="updateOneCategory(item)"><tkd-icon name="move"/></button>
                      <button type="button" class="adm-icon-btn sm danger"
                              title="Прибрати з відділення"
                              aria-label="Прибрати з відділення"
                              @mousedown.stop
                              @click.stop="removeCategoryFromSection(item)"><tkd-icon name="close"/></button>
                    </div>
                  </div>
                </div>
                <div class="section-drop-hint" v-if="!getVisibleCategoriesForSection(section.id).length">
                  Перетягніть категорії сюди
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { iconSvg } from 'src/components/TkdIcon/icons';
import FormCategorySection from 'src/pages/tournament/_formCategorySection.vue';
import FormSection from 'src/pages/tournament/_formSection.vue';
import {Sortable, Plugins, DragStartEvent, DragStopEvent} from '@shopify/draggable';
import FormCategory from 'src/pages/tournament/_formCategory.vue';
import TournamentCategoryList from 'src/components/TournamentCategoryList.vue';
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';

export default {
  name: "tab-categories",
  components: {
    'form-category-section': FormCategorySection,
    'form-section': FormSection,
    'tournament-category-list': TournamentCategoryList,
  },

  data: function () {

    return {
      sortableCategoyDay: '',
      sectionsSortable: null,
      sectionCategoriesSortable: null,
      isSavingSectionsOrder: false,
      isSavingSectionCategoriesOrder: false,
      sectionCategoryRequestQueue: Promise.resolve(),
      pendingSectionCategoryRequests: 0,
      selectedCategoryIds: [],
      // drag & drop з нерозподілених у відділення
      draggingCategoryIds: [],
      dragOverSectionId: null,
      isAssigning: false,
      selectedCategoryId: 0,
      visibleAvailableCategories: [],
      sectionCategories: [],
      orderedSections: [],
      formCategoryData: {
        id: '',
        section: '',
        name: '',
      },

      formSectionData: {
        id: '',
        sectionName: '',
        start_number: '',
      },
    }
  },


  computed: {
    activeTab() {
      return this.$store.getters['settings/activeTournamentTab'];
    },

    actionTournamentAddCategory() {
      return this.$store.getters['settings/actionTournamentAddCategory'];
    },

    activeTournamentCategoryTab() {
      return this.$store.getters['settings/activeTournamentCategoryTab'];
    },

    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    allProtocols() {
      if (this.tournamentOne.data && this.tournamentOne.data.item && this.tournamentOne.data.item.protocols) {
        return this.tournamentOne.data.item.protocols;
      }
      return [];
    },
    availableProtocols() {
      return this.sectionCategories.filter(item => !Number(item.sectionid));
    },

    availableWithSportsmans() {
      return this.availableProtocols.filter(item => this.getCategoryCount(item) > 0).length;
    },

    isBusy() {
      return this.isSavingSectionsOrder || this.isSavingSectionCategoriesOrder || this.isAssigning;
    },

    allCategoriesSelected() {
      return this.visibleAvailableCategories.length > 0 && this.selectedCategoryIds.length === this.visibleAvailableCategories.length;
    },
  },

  watch: {
    visibleAvailableCategories() {
      const categoryIds = this.visibleAvailableCategories.map(item => item.id);
      this.selectedCategoryIds = this.selectedCategoryIds.filter(id => categoryIds.indexOf(id) !== -1);
    },
    allProtocols: {
      handler(protocols) {
        this.syncSectionCategories(protocols);
        this.$nextTick(() => {
          this.initSectionCategoriesSortable();
        });
      },
      immediate: true,
      deep: true,
    },
    'tournamentOne.data.item.sections': {
      handler(sections) {
        this.syncOrderedSections(sections);
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.syncSectionCategories(this.allProtocols);
    this.syncOrderedSections(this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item
      ? this.tournamentOne.data.item.sections
      : []);
  },

  beforeDestroy() {
    this.destroySectionSortable();
    this.destroySectionCategoriesSortable();
  },



  methods: {
    syncSectionCategories(categories) {
      this.sectionCategories = Array.isArray(categories) ? categories.slice() : [];
    },
    syncOrderedSections(sections) {
      this.orderedSections = Array.isArray(sections) ? sections.slice() : [];
      this.$nextTick(() => {
        this.initSectionSortable();
        // контейнери категорій перемальовуються разом з відділеннями
        this.initSectionCategoriesSortable();
      });
    },

    initSectionSortable() {
      const container = this.$refs.sectionsLanes;

      if (!container) {
        return;
      }

      this.destroySectionSortable();

      this.sectionsSortable = new Sortable(container, {
        draggable: '.section-lane',
        // тягнемо лише за ⠿, щоб клік по картці/кнопках не починав перетягування
        handle: '.section-drag-handle',
        mirror: {
          constrainDimensions: true,
        },
      });

      this.sectionsSortable.on('sortable:stop', this.handleSectionSortStop);
    },

    destroySectionSortable() {
      if (!this.sectionsSortable) {
        return;
      }

      this.sectionsSortable.off('sortable:stop', this.handleSectionSortStop);
      this.sectionsSortable.destroy();
      this.sectionsSortable = null;
    },

    initSectionCategoriesSortable() {
      const containers = this.$el
        ? Array.from(this.$el.querySelectorAll('.section-categories-list'))
        : [];

      if (!containers.length) {
        this.destroySectionCategoriesSortable();
        return;
      }

      this.destroySectionCategoriesSortable();

      this.sectionCategoriesSortable = new Sortable(containers, {
        draggable: '.section-category-item',
        mirror: {
          constrainDimensions: true,
        },
      });

      this.sectionCategoriesSortable.on('sortable:stop', this.handleSectionCategorySortStop);
    },

    destroySectionCategoriesSortable() {
      if (!this.sectionCategoriesSortable) {
        return;
      }

      this.sectionCategoriesSortable.off('sortable:stop', this.handleSectionCategorySortStop);
      this.sectionCategoriesSortable.destroy();
      this.sectionCategoriesSortable = null;
    },

    handleSectionSortStop() {
      if (this.isSavingSectionsOrder) {
        return;
      }

      const container = this.$refs.sectionsLanes;

      if (!container) {
        return;
      }

      const sectionIds = Array.from(container.querySelectorAll('.section-lane'))
        .map(item => Number(item.getAttribute('data-section-id')))
        .filter(Boolean);

      if (!sectionIds.length) {
        return;
      }

      const nextSections = sectionIds
        .map(sectionId => this.orderedSections.find(section => Number(section.id) === sectionId))
        .filter(Boolean);

      const hasChanged = nextSections.length === this.orderedSections.length
        && nextSections.some((section, index) => Number(section.id) !== Number(this.orderedSections[index].id));

      if (!hasChanged) {
        return;
      }

      this.orderedSections = nextSections;
      this.saveSectionsOrder();
    },

    handleSectionCategorySortStop() {
      const containers = this.$el
        ? Array.from(this.$el.querySelectorAll('.section-categories-list'))
        : [];

      if (!containers.length) {
        return;
      }

      const categoryMap = this.sectionCategories.reduce((acc, item) => {
        acc[Number(item.id)] = item;
        return acc;
      }, {});

      const updates = [];
      const orderedIds = [];

      containers.forEach(container => {
        const sectionId = Number(container.getAttribute('data-section-id'));
        const categoryIds = Array.from(container.querySelectorAll('.section-category-item'))
          .map(item => Number(item.getAttribute('data-category-id')))
          .filter(Boolean);

        categoryIds.forEach((categoryId, index) => {
          const category = categoryMap[categoryId];
          if (!category) {
            return;
          }

          orderedIds.push(categoryId);
          updates.push({
            id: categoryId,
            sectionid: sectionId,
            position: index + 1,
          });
        });
      });

      if (!updates.length) {
        return;
      }

      const unchanged = updates.every(update => {
        const current = categoryMap[update.id];
        return current
          && Number(current.sectionid) === update.sectionid
          && Number(current.section_position || 0) === update.position;
      });

      if (unchanged) {
        return;
      }

      const previousSectionCategories = this.sectionCategories.slice();
      const remainingCategories = this.sectionCategories.filter(item => orderedIds.indexOf(Number(item.id)) === -1);
      const reorderedSectionCategories = updates
        .map(update => {
          const category = categoryMap[update.id];
          return {
            ...category,
            sectionid: update.sectionid,
            section_position: update.position,
          };
        });

      this.sectionCategories = reorderedSectionCategories.concat(remainingCategories);
      this.queueSectionCategorySync(updates, previousSectionCategories);
    },

    saveSectionsOrder() {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.id) {
        return;
      }

      const params = {
        tournament_id: this.tournamentOne.data.item.id,
        sections: this.orderedSections.map((section, index) => ({
          id: section.id,
          position: index + 1,
        })),
      };

      this.isSavingSectionsOrder = true;

      this.$store.dispatch('tournament_section/setSectionsOrder', params)
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
        .then(() => {
          this.$notify({
            text: 'Порядок відділень збережено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 6000,
            speed: 1000,
            type: 'success'
          });
        })
        .catch(error => {
          const responseMessage = error && error.response && error.response.data
            ? error.response.data.message || error.response.data.error
            : '';

          this.syncOrderedSections(this.tournamentOne.data.item.sections);

          this.$notify({
            text: responseMessage || 'Помилка. Порядок відділень не збережено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'error'
          });
        })
        .finally(() => {
          this.isSavingSectionsOrder = false;
        });
    },

    queueSectionCategorySync(updates, previousSectionCategories) {
      this.pendingSectionCategoryRequests += 1;
      this.isSavingSectionCategoriesOrder = true;

      const movedCategories = updates.filter(update => {
        const currentCategory = previousSectionCategories.find(item => Number(item.id) === Number(update.id));
        return currentCategory && Number(currentCategory.sectionid) !== Number(update.sectionid);
      });

      const request = () => {
        return this.saveSectionCategoriesOrder(updates);
      };

      this.sectionCategoryRequestQueue = this.sectionCategoryRequestQueue
        .catch(() => null)
        .then(request)
        .then(() => {
          this.$notify({
            text: movedCategories.length
              ? 'Категорії між відділеннями оновлено'
              : 'Порядок категорій оновлено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 6000,
            speed: 1000,
            type: 'success'
          });
        })
        .catch(error => {
          const responseMessage = error && error.response && error.response.data
            ? error.response.data.message || error.response.data.error
            : '';

          this.sectionCategories = previousSectionCategories.slice();

          this.$notify({
            text: responseMessage || 'Помилка. Категорії не переміщено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'error'
          });
        })
        .finally(() => {
          this.pendingSectionCategoryRequests = Math.max(0, this.pendingSectionCategoryRequests - 1);

          if (!this.pendingSectionCategoryRequests) {
            this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id})
              .finally(() => {
                this.isSavingSectionCategoriesOrder = false;
              });
            return;
          }

          this.isSavingSectionCategoriesOrder = true;
        });
    },

    saveSectionCategoriesOrder(updates) {
      if (!this.tournamentOne.data || !this.tournamentOne.data.item || !this.tournamentOne.data.item.id) {
        return Promise.resolve();
      }

      const tournamentId = this.tournamentOne.data.item.id;
      return updates.reduce((chain, update) => chain.then(() => (
        this.$store.dispatch('tournament_section/setCategorySection', {
          id: update.id,
          tournament_id: tournamentId,
          sectionid: update.sectionid,
          section_position: update.position,
          position: update.position,
        })
      )), Promise.resolve());
    },

    syncVisibleCategories(categories) {
      this.visibleAvailableCategories = categories;
    },

    getVisibleCategoriesForSection(sectionId) {
      return this.sectionCategories.filter(item => Number(item.sectionid) === Number(sectionId));
    },

    getCategoryCount(category) {
      return category.count_sportsmans || category.count || 0;
    },

    getCategoryFightCount(category) {
      // Керугі в сітці: кожен спортсмен, крім переможця, програє один поєдинок.
      // Пумсе та спискові категорії не мають поєдинків.
      if (String(category.type) === '2' || String(category.show_type) === '2') {
        return 0;
      }

      const sportsmanCount = Number(this.getCategoryCount(category)) || 0;
      return Math.max(0, sportsmanCount - 1);
    },

    getSectionFightCount(sectionId) {
      return this.getVisibleCategoriesForSection(sectionId)
        .reduce((total, category) => total + this.getCategoryFightCount(category), 0);
    },

    getNumerationCategoryClass(category) {
      if (String(category.sex) === '1') {
        return 'man-category';
      }

      if (String(category.sex) === '2') {
        return 'woman-category';
      }

      return 'other-category';
    },

    isCategorySelected(categoryId) {
      return this.selectedCategoryIds.indexOf(categoryId) !== -1;
    },

    toggleCategorySelection(categoryId, checked) {
      if (checked) {
        if (!this.isCategorySelected(categoryId)) {
          this.selectedCategoryIds.push(categoryId);
        }
        return;
      }

      this.selectedCategoryIds = this.selectedCategoryIds.filter(id => id !== categoryId);
    },

    toggleAllCategoriesSelection(checked) {
      if (checked) {
        this.selectedCategoryIds = this.visibleAvailableCategories.map(item => item.id);
        return;
      }

      this.selectedCategoryIds = [];
    },

    clearCategorySelection() {
      this.selectedCategoryIds = [];
    },

    assignSelectedCategoriesToSection(section) {
      this.assignCategoriesToSection(section, this.selectedCategoryIds.slice());
    },

    assignCategoriesToSection(section, categoryIds) {
      if (!categoryIds.length || this.isAssigning) {
        return;
      }

      const params = {
        tournament_id: this.tournamentOne.data.item.id,
        sectionid: section.id,
        category_ids: categoryIds,
      };

      // одразу показуємо категорії у відділенні; при помилці повертаємо як було
      const previousSectionCategories = this.sectionCategories.slice();
      const lastPosition = this.getVisibleCategoriesForSection(section.id).length;
      this.sectionCategories = this.sectionCategories.map(item => {
        const index = categoryIds.indexOf(item.id);
        return index === -1 ? item : {...item, sectionid: section.id, section_position: lastPosition + index + 1};
      });
      this.selectedCategoryIds = this.selectedCategoryIds.filter(id => categoryIds.indexOf(id) === -1);
      this.isAssigning = true;

        this.$store.dispatch('tournament_section/setCategoriesSection', params)
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
        .then(() => {
          this.$notify({
            text: 'Категорії призначено до відділення',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'success'
          });
        })
        .catch(error => {
          const responseMessage = error && error.response && error.response.data
            ? error.response.data.message || error.response.data.error
            : '';

          this.sectionCategories = previousSectionCategories;

          this.$notify({
            text: responseMessage || 'Помилка. Категорії не призначено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'error'
          });
        })
        .finally(() => {
          this.isAssigning = false;
        });
    },

    // клік по картці в списку = вибрати / зняти вибір
    toggleCategoryFromClick(category) {
      this.toggleCategorySelection(category.id, !this.isCategorySelected(category.id));
    },

    onCategoryDragStart(category, event) {
      // якщо тягнемо одну з вибраних — переносимо всі вибрані
      const ids = this.isCategorySelected(category.id) && this.selectedCategoryIds.length > 1
        ? this.selectedCategoryIds.slice()
        : [category.id];
      this.draggingCategoryIds = ids;

      if (event && event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.setData('text/plain', ids.join(','));

        if (ids.length > 1) {
          const ghost = document.createElement('div');
          ghost.className = 'num-drag-ghost';
          ghost.innerHTML = iconSvg('section') + ' ' + ids.length + ' категорій';
          document.body.appendChild(ghost);
          event.dataTransfer.setDragImage(ghost, 20, 20);
          setTimeout(() => ghost.remove(), 0);
        }
      }
    },

    onCategoryDragEnd() {
      this.draggingCategoryIds = [];
      this.dragOverSectionId = null;
    },

    onLaneDragOver(section, event) {
      if (!this.draggingCategoryIds.length) {
        return;
      }
      event.preventDefault();
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move';
      }
      this.dragOverSectionId = section.id;
    },

    onLaneDragLeave(section, event) {
      if (event.currentTarget.contains(event.relatedTarget)) {
        return;
      }
      if (this.dragOverSectionId === section.id) {
        this.dragOverSectionId = null;
      }
    },

    onLaneDrop(section, event) {
      if (!this.draggingCategoryIds.length) {
        return;
      }
      event.preventDefault();
      const ids = this.draggingCategoryIds.slice();
      this.onCategoryDragEnd();
      this.assignCategoriesToSection(section, ids);
    },

    // ті самі параметри, що й кнопка «Пронумерувати» у формі відділення
    numerateSection(section) {
      if (!window.confirm('Пронумерувати поєдинки відділення «' + section.name + '»? Всі попередні номера в даному відділенні будуть стерті')) {
        return;
      }

      const params = {id: section.id, name: section.name, start_number: section.start_number};
      this.isAssigning = true;

      this.$store.dispatch('tournament_section/fightNumeration', params)
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
        .then(() => {
          this.$notify({
            text: 'Поєдинки відділення «' + section.name + '» пронумеровано',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 6000,
            speed: 1000,
            type: 'success'
          });
        })
        .finally(() => {
          this.isAssigning = false;
        });
    },

    removeCategoryFromSection(category) {
      const params = {
        id: category.id,
        tournament_id: this.tournamentOne.data.item.id,
        sectionid: 0,
      };

      this.$store.dispatch('tournament_section/setCategorySection', params)
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
        .then(() => {
          this.selectedCategoryIds = this.selectedCategoryIds.filter(id => id !== category.id);
          this.$notify({
            text: 'Категорію видалено з відділення',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'success'
          });
        })
        .catch(error => {
          const responseMessage = error && error.response && error.response.data
            ? error.response.data.message || error.response.data.error
            : '';

          this.$notify({
            text: responseMessage || 'Помилка. Категорію не видалено з відділення',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'error'
          });
        });
    },

    // удаление одной категории с турнира
    updateOneCategory(category) {
      this.selectedCategoryId = category.id;
      console.log(category);
      //   // this.formAddSportsman.first_name = sportsman.first_name;
      this.formCategoryData.name = category.fullname;
      this.formCategoryData.id = category.id;
      // у протоколу поле sectionid (раніше порівнювали з category.section, і цикл не виконувався)
      this.formCategoryData.section = '';
      const sections = this.tournamentOne.data.item.sections || [];
      for (let i = 0; i < sections.length; i++) {
        if (Number(category.sectionid) === Number(sections[i].id)) {
          this.formCategoryData.section = sections[i];
        }
      }

      console.log(this.formCategoryData);

      this.$modal.show('category-section-form-modal');
    },
    resetSectionForm(){
      this.formSectionData = {
        id: '',
        name: '',
        start_number: '',
      }
    },
    getSectionNameForCategory(category){

      console.log('category', category);

      if(category.sectionid != null && category.sectionid > 0){
        for (const categoryKey in this.tournamentOne.data.item.sections) {

          console.log('this.tournamentOne.data.item.sections[categoryKey]', this.tournamentOne.data.item.sections[categoryKey]);
          if(category.sectionid == this.tournamentOne.data.item.sections[categoryKey].id){
            return this.tournamentOne.data.item.sections[categoryKey].name;
          }
        }
      }

      return "";
    },

    addNewSection(){
      this.resetSectionForm();
      this.$modal.show('section-form-modal');
    },

    updateSection(section){
      this.resetSectionForm();

      console.log('section', section);

      this.formSectionData.id = section.id;
      this.formSectionData.name = section.name;
      this.formSectionData.start_number = section.start_number;
      this.$modal.show('section-form-modal');
    },


    deleteOneCategory(id) {

      if (window.confirm(" Після видалення дані неможливо буде відновити. Ви впевнені, що хочете видали категорію з турніру?")) {
        let params = {'id': id};
        this.$store.dispatch('tournament/deleteOneCategory', params)
          .then(() => this.deleteFromListCategory(id));
      }
    },
    deleteFromListCategory(id) {
      let length = this.tournamentOne.data.item.protocols.length;
      for (let i = 0; i < length; i++) {
        console.log(this.tournamentOne.data.item.protocols[i].id);
        if (this.tournamentOne.data.item.protocols[i].id === id) {
          this.tournamentOne.data.item.protocols.splice(i, 1);
          break;
        }
      }
    },



    showCategoryForm() {
      this.$modal.show('category-form-modal');
    },
    hideCategoryForm() {
      this.$modal.hide('category-form-modal');
    },


    setActiveCategoryTab(position) {
      this.$store.dispatch('settings/setActiveTournamentCategoryTab', position);
    },

    resortCategoryDays() {
      let day1 = document.getElementById('day1');
      let day2 = document.getElementById('day2');
      let itemsDay1 = day1.getElementsByClassName('category-item');
      let itemsDay2 = day2.getElementsByClassName('category-item');

      let categoryId = '';
      let day1ids = [];
      let day1position = [];
      let day2ids = [];
      let day2position = [];


      let i = 0;
      for (i = 0; i < itemsDay1.length; i++) {
        if (itemsDay1[i] == undefined) {
          continue;

        }
        if (itemsDay1[i].classList.contains('draggable-mirror')) {

        } else if (itemsDay1[i].classList.contains('draggable-mirror')) {

        } else if (itemsDay1[i].classList.contains('draggable--original')) {

        } else {

          console.log(itemsDay1[i]);
          categoryId = itemsDay1[i].getAttribute('data-category-id');

          day1ids.push(categoryId);
          day1position.push({id: categoryId, position: i})
        }

      }

      i++;
      for (let k = 0; k < itemsDay2.length; k++) {
        if (itemsDay2[i] == undefined) {
          continue;

        }
        if (itemsDay2[i].classList.contains('draggable-mirror')) {

        } else if (itemsDay2[k].classList.contains('draggable-mirror')) {

        } else if (itemsDay2[k].classList.contains('draggable--original')) {

        } else {
          categoryId = itemsDay2[k].getAttribute('data-category-id');
          day2ids.push(categoryId);
          day2position.push({id: categoryId, position: (k + i)})
        }

      }


      console.log('itemsDay1', itemsDay1);

      let params = {
        day1ids: day1ids,
        day2ids: day2ids,
        day1position: day1position,
        day2position: day2position,
      };
      console.log('params', params);
      this.$store.dispatch('tournament/setCategoryDays', params)
        // .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.id}))
        .catch(error => {
          alert('Помилка сервера');
        });
    },


  }
}
</script>


<style scoped>
.tab-numeration {
  /* перекриває .tournament-content-tab { background:#fff } з _custom.scss */
  background: transparent;
  font-family: var(--tkd-font);
  color: var(--tkd-text);
}

.num-head-stats { display: flex; flex-wrap: wrap; gap: 8px; margin-right: auto; }
.num-saving { border-color: var(--tkd-navy); }

/* Дві колонки: нерозподілені | відділення */
.num-workspace {
  display: grid;
  grid-template-columns: minmax(300px, 380px) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.num-picker {
  position: sticky;
  top: 72px;
  max-height: calc(100vh - 88px);
  margin-bottom: 0;
  padding: 16px;
  overflow-y: auto;
  scrollbar-width: thin;
}

/* фільтри списку у вузькій колонці — один стовпчик */
.num-picker >>> .adm-filter-grid { grid-template-columns: minmax(0, 1fr); gap: 8px; }
.num-picker >>> .category-filters-row { margin-bottom: 12px; }
.num-picker >>> .cl-title { font-size: 16px; }

.num-picker-empty {
  margin: 8px 0 0;
  padding: 14px;
  border-radius: var(--tkd-radius);
  background: var(--adm-ok-bg);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: var(--adm-ok);
}

/* картка в списку: місце під чекбокс праворуч */
.num-picker >>> .category-item-main { padding-right: 34px; }

.category-selection-checkbox-floating {
  position: absolute;
  top: 50%;
  right: 10px;
  z-index: 2;
  width: 18px;
  height: 18px;
  margin: 0;
  transform: translateY(-50%);
  accent-color: var(--tkd-navy);
  cursor: pointer;
}

.num-sections { min-width: 0; }

.num-selection-bar {
  position: sticky;
  top: 72px;
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
  padding: 8px 8px 8px 16px;
  border-radius: var(--tkd-radius);
  background: var(--tkd-navy);
  box-shadow: 0 8px 20px rgba(10, 31, 68, 0.25);
  font-size: 14px;
  color: #fff;
}

.num-selection-bar .adm-btn-ghost { color: #fff; }
.num-selection-bar .adm-btn-ghost:hover { border-color: rgba(255, 255, 255, 0.3); background: rgba(255, 255, 255, 0.1); color: #fff; }

.num-hint { max-width: 420px; font-size: 14px; }

/* Відділення: сітка карток */
.sections-lanes {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  align-items: start;
}

.section-lane-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--tkd-border);
  border-radius: var(--tkd-radius-lg);
  background: var(--tkd-surface);
  box-shadow: var(--tkd-shadow);
  transition: border-color 0.15s, box-shadow 0.15s;
}

/* під час перетягування — підказуємо, куди можна кинути */
.section-lane.is-drop-target .section-lane-card { border-style: dashed; border-color: var(--tkd-muted); }
.section-lane.is-drag-over .section-lane-card {
  border-style: solid;
  border-color: var(--adm-ok-strong);
  background: var(--adm-ok-bg);
  box-shadow: 0 0 0 3px rgba(23, 178, 106, 0.2);
}

.section-card {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  /* перекриває глобальне .section-card { background:#ccc; padding:5px } */
  padding: 0;
  border-bottom: 0;
  background: transparent;
}

.section-drag-handle {
  flex-shrink: 0;
  padding: 2px 4px;
  border-radius: 6px;
  font-size: 18px;
  line-height: 1;
  color: var(--tkd-muted);
  cursor: grab;
  user-select: none;
}

.section-drag-handle:hover { background: var(--tkd-bg); color: var(--tkd-text); }
.section-drag-handle:active { cursor: grabbing; }

.start-number {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  background: var(--tkd-navy);
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.section-name {
  flex: 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.section-edit { flex-shrink: 0; width: 32px; height: 32px; font-size: 13px; }

.section-stats, .section-actions { display: flex; flex-wrap: wrap; gap: 6px; }

.section-categories-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 64px;
  padding: 6px;
  border-radius: var(--tkd-radius);
  background: var(--tkd-bg);
}

.section-drop-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  border: 2px dashed var(--tkd-border);
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--tkd-muted);
}

/* Категорія у відділенні */
.section-category-item {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--tkd-border);
  border-left-width: 3px;
  border-radius: 10px;
  background: var(--tkd-surface);
  cursor: grab;
  user-select: none;
}

.section-category-item:hover { border-color: var(--tkd-muted); }
.section-category-item:active { cursor: grabbing; }
.section-category-item.man-category { border-left-color: #475467; }
.section-category-item.woman-category { border-left-color: #98a2b3; }
.section-category-item.other-category { border-left-color: #d0d5dd; }

.category-item-inner {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  min-height: 100%;
}

.category-item-side {
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--tkd-border);
  background: var(--tkd-bg);
  font-weight: 800;
}

.category-item-main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 7px 8px;
  font-size: 13px;
}

.category-item-name { min-width: 0; font-weight: 600; overflow-wrap: anywhere; }

.category-count-sportsmans {
  width: 100%;
  font-size: 13px;
  line-height: 1;
  text-align: center;
  font-variant-numeric: tabular-nums;
}

.numeration-dop-info { display: flex; flex-wrap: wrap; gap: 4px; }
.numeration-dop-info .adm-chip { font-size: 11px; }

.category-item-tools { display: flex; align-items: center; gap: 4px; padding-right: 6px; }
.adm-icon-btn.sm { width: 28px; height: 28px; font-size: 12px; border-radius: 8px; }

/* Shopify Draggable: копія під курсором і місце, звідки тягнемо */
.section-category-item.draggable-mirror,
.section-lane.draggable-mirror { box-shadow: 0 12px 30px rgba(10, 31, 68, 0.25); opacity: 0.95; }
.section-category-item.draggable-source--is-dragging,
.section-lane.draggable-source--is-dragging { opacity: 0.35; }

@media (max-width: 1199px) {
  .num-workspace { grid-template-columns: minmax(0, 1fr); }
  .num-picker { position: static; max-height: 55vh; }
}

@media (max-width: 480px) {
  .sections-lanes { grid-template-columns: minmax(0, 1fr); }
}

@media (prefers-reduced-motion: reduce) {
  .section-lane-card { transition: none; }
}
</style>

<style>
/* картинка під курсором при перетягуванні кількох категорій (живе в <body>) */
.num-drag-ghost {
  position: fixed;
  top: -100px;
  left: -100px;
  padding: 8px 14px;
  border-radius: 10px;
  background: #0a1f44;
  font: 700 14px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #fff;
}
</style>
